module.exports = __webpack_public_path__ + "img/kecheng.6ac5a5f4.png";